import React, {Component} from 'react'
import AplikacjaMobilna from "./AplikacjaMobilna";
import Footer from "../../shared/Footer";
import {Button} from "react-bootstrap";
import BOKService from "../../konto/panel/panelComponents/bokComponents/BOKService";
import {NotificationManager} from "react-notifications";
import {Link, Redirect} from "react-router-dom";

export default class Kontakt extends Component {

    constructor(props) {
        super(props);

        this.state = {
            warunki: true,
            email: '',
            imie: '',
            nazwisko: '',
            tresc: '',
            nrRez: '',
            imieInvalid: false,
            nazwiskoInvalid: false,
            trescInvalid: false,
            mailInvalid: false,
            nrRezInvalid: false
        };
        this.handleEmail = this.handleEmail.bind(this);
        this.handleImie = this.handleImie.bind(this);
        this.handleTresc = this.handleTresc.bind(this);
        this.handleNazwisko = this.handleNazwisko.bind(this);
        this.handleNrRez = this.handleNrRez.bind(this);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    handleEmail(e) {
        this.setState({email: e.target.value})
    }

    handleImie(e) {
        this.setState({imie: e.target.value})
    }

    handleTresc(e) {
        this.setState({tresc: e.target.value})
    }

    handleNazwisko(e) {
        this.setState({nazwisko: e.target.value})
    }

    handleNrRez(e) {
        this.setState({nrRez: e.target.value})
    }

    postZgloszenie() {
        let name = '';
        let type = '';
        let size = 0;
        let plik = null;

        BOKService.postZgloszenieNieZal(this.state.email, this.state.imie,
            this.state.nazwisko, this.state.nrRez, plik, name, size, type,
            'Zwrot biletu nr ' + this.state.nrRez, this.state.tresc, 1)
            .then(function (response) {
                this.setState({
                    email: '',
                    imie: '',
                    nazwisko: '',
                    nrRez: '',
                    imieInvalid: false,
                    nazwiskoInvalid: false,
                    trescInvalid: false,
                    nrRezInvalid: false,
                    mailInvalid: false
                });
                NotificationManager.success("", "Twoje zgłoszenie zostało wysłane.", 5000);

            }.bind(this))
    }

    wyslijZgloszenie() {
        let mail, imie, nazwisko, nrRez, tresc;
        if (this.state.email.length === 0) {
            mail = true
        }
        if (this.state.imie.length === 0) {
            imie = true
        }
        if (this.state.nazwisko.length === 0) {
            nazwisko = true
        }
        if (this.state.tresc.length === 0) {
            tresc = true
        }
        if (this.state.nrRez.length === 0 || isNaN(this.state.nrRez)) {
            nrRez = true
        }
        if (!imie && !nazwisko && !mail && !nrRez && !tresc) {
            this.postZgloszenie()
        } else {
            this.setState({
                mailInvalid: mail,
                imieInvalid: imie,
                trescInvalid: tresc,
                nazwiskoInvalid: nazwisko,
                nrRezInvalid: nrRez
            })
        }
    }

    render() {
        return <div>

            <div className="wynajemNaglowek przerywnik">
                <div className="container text-center">
                    <h2><b>Skontaktuj się z nami przez nasz formularz.</b></h2>
                    <h4>Nasi konsultanci pomogą znaleźć rozwiązanie.</h4>
                </div>
            </div>
            <div style={{background: '#efefef', paddingTop: '25px', paddingBottom: '25px'}}
                 className="paddingContainerMobilka">
                <div className="container ramka" style={{background: '#fff', padding: 50}}>
                    <div className="text-center"><h2 style={{fontWeight: 'bold'}}>Zwrot biletu</h2></div>
                    <hr/>
                    <div>
                        <h6><strong>Pasażer, który zakupił bilet on-line i nie będzie mógł skorzystać z przejazdu,
                            zobowiązany jest przed podróżą wypełnić formularz na stronie internetowej i poinformować o
                            tym fakcie telefonicznie biuro obsługi: 795 005 006 lub 600 200 585.</strong></h6>
                        <br/>
                        <h6 style={{textAlign: 'justify'}}>Zwrot należności za niewykorzystany bilet realizowany jest
                            zgodnie z punktem 3.5 Regulaminu ogólnego o treści:</h6>
                        <blockquote className='typo_style2'><p><strong>3.5.</strong> Do obliczenia zwracanej należności
                            przyjmuje się:</p>
                            <p>a) za bilety na przejazd jednorazowy:</p>
                            <p>– w razie całkowitego niewykorzystania biletu – zapłaconą należność,</p>
                            <p>– w razie częściowego niewykorzystania biletu – różnicę między zapłaconą należnością, a
                                należnością przypadającą za wykonane świadczenie,</p>
                            <p>b) za bilety na przejazd wielokrotny:</p>
                            <p>– zapłaconą należność za bilet zwrócony przed pierwszym dniem terminu jego ważności
                                (zwrotu dokonuje kasa biletowa),</p>
                            <p style={{textAlign: 'justify'}}>– należność proporcjonalną do liczby niewykorzystanych
                                przejazdów, o ile bilet został zwrócony w okresie jego ważności, w trybie pisemnej
                                reklamacji.</p></blockquote>
                        <p style={{textAlign: 'justify'}}>
                            <blockquote className='typo_style2'><p><strong>3.7</strong> Od zwracanych Pasażerowi przez
                                Przewoźnika należności zgodnie z art. 17 ust. 4 Ustawy prawo przewozowe, Przewoźnik
                                potrąca 20% odstępnego. Minimalna opłata przy zwrocie wynosi 1,10 zł.</p></blockquote>
                        </p>
                    </div>
                    <hr/>
                    <div className={'text-center'}>
                        <p>Aby zwrócić bilet należy skorzystać z formularza kontaktowego z wyborem opcji
                            {sessionStorage.getItem('loggedIn') !== null ?
                                <Link to={'/konto/bok/dodaj-zgloszenie#zwrot'}> Zwrot biletu</Link> : <Link to={'/kontakt#zwrot'}> Zwrot biletu</Link>}
                            .</p>
                    </div>
                </div>
            </div>
            {/*<AplikacjaMobilna/>*/}
            <Footer/>
        </div>
    }


}



// WEBPACK FOOTER //
// ./src/components/home/homeComponents/ZwrotBiletu.js